export default __webpack_public_path__ + "static/media/favicon.05e709a5.ico";